var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.2 42H84V39.2H81.2V42ZM42 78.4C21.8969 78.4 5.60005 62.1032 5.60005 42H4.88758e-05C4.88758e-05 65.1959 18.8041 84 42 84V78.4ZM78.4 42C78.4 62.1032 62.1032 78.4 42 78.4V84C65.196 84 84 65.1959 84 42H78.4ZM42 -1.21593e-05C18.8041 -1.21593e-05 4.88758e-05 18.804 4.88758e-05 42H5.60005C5.60005 21.8968 21.8969 5.59999 42 5.59999V-1.21593e-05ZM42 5.59999C52.1858 5.59999 61.3902 9.78002 68.0002 16.5254L71.9999 12.606C64.3801 4.82999 53.7516 -1.21593e-05 42 -1.21593e-05V5.59999ZM44.8 44.8H81.2V39.2H44.8V44.8Z",
    fill: "#010100"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f8007f3a5308f860d6e06cefe090cd83.svg";
export { ForwardRef as ReactComponent };